/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档



export interface API77090Req {
  
  /** 应用编码 */
  appCode?: string;
  /** 应用名称 */
  appName: string;
  /** 应用描述 */
  appDesc?: string;
};



export type API77090Res = {};


// 接口函数 77090 保存应用

export interface IUsePostAPI77090Return {
  /** 保存应用: 接口请求状态 */
  isAPI77090Loading: boolean;
  /** 保存应用: 接口请求返回数据 */
  dataAPI77090: API77090Res;
  /**  保存应用: 接口数据请求方法 */
  fetchAPI77090Data: (inputs: API77090Req, config?: YWRequestConfig) => Promise<API77090Res>;
  /** 保存应用: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77090 = ():IUsePostAPI77090Return => {
  let isMount = true;
  const [isAPI77090Loading, setIsAPI77090Loading] = useState(false);
  const [dataAPI77090, setDataAPI77090] = useState<API77090Res>({} as API77090Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/save`;

  const fetchAPI77090Data = async (inputs: API77090Req, config?: YWRequestConfig): Promise<API77090Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77090Req>) || {}) as API77090Req;
    
  
    if ( isMount ) {
      setIsAPI77090Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77090Res>(`${basePath}/yoaichat-admin/app/save`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77090(res || {} as API77090Res);
        setIsAPI77090Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77090Loading(false);
      }
      return false as unknown as API77090Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77090Loading,
    dataAPI77090,
    fetchAPI77090Data,
    requestUrl,
  }
}

